import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils';
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  icon?: React.ReactNode;
}
const Input = forwardRef<HTMLInputElement, InputProps>(({
  className,
  type,
  error,
  icon,
  ...props
}, ref) => {
  return <div className="relative w-full" data-id="element-1855">
        {icon && <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-muted-foreground" data-id="element-1856">
            {icon}
          </div>}
        <input type={type} className={cn('flex h-11 w-full rounded-xl border bg-background px-4 py-2 text-base sm:text-sm', 'file:border-0 file:bg-transparent file:text-sm file:font-medium', 'placeholder:text-muted-foreground', 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-0', 'disabled:cursor-not-allowed disabled:opacity-50', 'transition-all duration-200', error ? 'border-destructive focus-visible:ring-destructive/30' : 'border-input', icon && 'pl-10', className)} ref={ref} {...props} data-id="element-1857" />
      </div>;
});
Input.displayName = 'Input';
export { Input };